<template>
	<div class="index" v-cloak>
		<!-- <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler">
		</baidu-map> -->
		<div class="follow acea-row row-between-wrapper" v-if="followHid && followUrl && !subscribe && isWeixin">
			<div>点击“立即关注”即可关注公众号</div>
			<div class="acea-row row-middle">
				<div class="bnt" @click="followTap">立即关注</div>
				<span class="iconfont icon-guanbi" @click="closeFollow"></span>
			</div>
		</div>
		<div class="followCode" v-if="followCode">
			<div class="pictrue">
				<img :src="followUrl" />
			</div>
			<div class="mask" @click="closeFollowCode"></div>
		</div>

		<div class="slider-banner banner">
			<swiper :options="swiperOption" v-if="banner.length > 0">
				<swiper-slide v-for="(item, index) in banner" :key="index">
					<router-link :to="item.wap_url ? item.wap_url : ''" class="search acea-row row-middle">
						<img :src="item.pic" />
					</router-link>
				</swiper-slide>
				<div class="swiper-pagination paginationBanner" slot="pagination"></div>
			</swiper>
		</div>


		<div class="header acea-row row-center-wrapper">
			<div class="logo">
				{{address.city}}
			</div>
			<router-link :to="'/search'" class="search acea-row row-middle">
				<span class="iconfont icon-xiazai5"></span>搜索商品
			</router-link>
		</div>


<!-- 五大选项 -->
		<div class="nav acea-row">
			<!-- <router-link :to="{  path: (index === menus.length-1)?item.wap_url+'/2' : item.wap_url ,query:{id:item.id, title:item.name}}" -->
			<router-link :to="{  path: item.wap_url ,query:{id:item.cateid, title:item.name}}"
			 class="item" v-for="(item, index) in menus" :key="index">
				<div class="pictrue"><img :src="item.pic" /></div>
				<div class="fitIdr">{{ item.name }}</div>
			</router-link>
		</div>
<!-- 店铺。门店 -->
		<div class="acer-dian">
			<div class="acer-img" v-for="i in teat">
				<img :src= i.img alt=""> 
			</div>
			<div class="acer-shang" v-for="(item, index) in info.fastList"> 
				<router-link :to="{
			      path: '/shps_list',
			      query: { id: item.id, title: item.cate_name }
			    }">
					<div class="acer-le">
						<img :src="item.pic" />
					</div>
					<div class="acer-rit">
						<h3>{{ item.cate_name }}</h3>
						<p style="font-size: 12px;">{{item.cate_fbt}}</p>
						<p>{{ item.cate_jianjie }}</p> 
					</div>
				</router-link>
			</div>
		</div> 
		<div class="hotList">
			<div class="hot-bg">
				<div class="title acea-row row-between-wrapper">
					<div class="text label">
						<p class="label">{{info.fastInfo}}</p> 
					</div>
					<router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
						更多<span class="iconfont icon-jiantou"></span>
					</router-link>
				</div>
			</div>
<!-- 店铺街 -->
			<div class="list acea-row row-middle">
				<router-link :to="{ path: '/conlet/' + item.id ,query:{id:item.id,adr:item.address }}" 
				class="item" 
				v-for="(item, index) in likeInfo"
				 :key="index"> 
					<div class="pictrue">
						<img :src="item.image" />
						<img src="@assets/images/one.png" class="numPic" v-if="index === 0" />
						<img src="@assets/images/two.png" class="numPic" v-else-if="index === 1" />
						<img src="@assets/images/three.png" class="numPic" v-else-if="index === 2" />
					</div>
					<div class="money font-color-red">
						<p class="num" style="font-size: 12px; font-weight: 200;">{{ item.name }}</p>
					</div>
				</router-link>
			</div>
		</div>
		<div v-if="newGoodsBananr">
			<div class="adver">
				<img :src="newGoodsBananr" />
			</div>
		</div>
		<div class="car_tet"> 
			<div class="car_p">
				<img :src = tetp alt="">
			</div>
		</div>
		<a :href=zscxUrl>
		<div style="height: 1.3rem;margin-top: 20px;"> 
				<img style="width: 100%;
		height: 100%;" :src=zscxImg alt=""> 
		</div>
		</a>
<!-- 视频播放 -->
		<div class="xf_max" v-for="item in videl">
			<div class="xf_val">
				<video  controls :src="item.video_url" style="width: 100%; height: 100%;"></video>
			</div>
			<div class="xf_tet">
				<h3>{{item.param}}</h3> 
			</div>
		</div>
		<!-- 底部banner -->
		<div class="bonLoop">
			<router-link :to="{  path: i.wap_url ,query:{id:i.cateid, title:i.name}}" v-for="i in botm">
				<img :src=i.pic alt=""> 
			</router-link>
		</div> 
		<div style="width:300px;margin:0 auto; padding:20px 0;">
			<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="text-decoration:none;height:20px;line-height:20px;">
			 <!-- <img src="../../assets/images/beian.png" style="float:left;" /> -->
			    <p style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;text-align: center;">
				 冀ICP备16011466号
				 </p >
			 </a>
			<a target="_blank" href="http://www.beian.gov.cn/portal/recordQuery?token=0b3988a1-b50e-43c4-ab68-03a50554fdc4" 
			style="text-decoration:none;height:20px;line-height:20px;        display: inline-block;
    vertical-align: middle;
    width: 100%;
    text-align: center;">
			 <img src="../../assets/images/beian.png" style="vertical-align: middle;" />
			 <p style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;text-align: center;    display: inline-block;">
				 <!-- 冀ICP备16011466号 -->
				 冀公网安备 13010202002778号</p >
			 </a>
		</div>
		<div style="width: 100%;height: 50px;"></div>
	</div>
</template>
<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "@assets/css/swiper.min.css";
	import GoodList from "@components/GoodList";
	import PromotionGood from "@components/PromotionGood";
	import CouponWindow from "@components/CouponWindow";
	import {
		getHomeData,
		getShare,
		follow
	} from "@api/public";
	import cookie from "@utils/store/cookie";
	import {
		openShareAll
	} from "@libs/wechat";
	import {
		isWeixin
	} from "@utils/index";
 
	import { getUser, getMenuUser } from "@api/user";  

	const HAS_COUPON_WINDOW = "has_coupon_window";

	export default {
		name: "Index",
		components: {
			swiper,
			swiperSlide,
			GoodList,
			PromotionGood,
			CouponWindow
		},
		props: {},
		data: function() {
			return {
				newGoodsBananr: "",
				isWeixin: isWeixin(),
				followUrl: "",
				subscribe: false,
				followHid: true,
				followCode: false,
				showCoupon: false,
				logoUrl: "",
				banner: [], 
				menus: [],
				roll: [],
				activity: [],
				activityOne: {},
				videl: {},
				tetp: {}, 
				botm:'',
				zscxImg:{},
				zscxUrl:{},
				teat:'',
				phone:'',
				info: {
					fastList: [],
					bastBanner: [],
					firstList: [],
					bastList: []
				}, 
				likeInfo: [],
				intet:[],
				lovely: [],
				benefit: [],
				couponList: [],
				swiperOption: {
					pagination: {
						el: ".paginationBanner",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperRoll: {
					direction: "vertical",
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperScroll: {
					freeMode: true,
					freeModeMomentum: false,
					slidesPerView: "auto",
					observer: true,
					observeParents: true
				},
				swiperBoutique: {
					pagination: {
						el: ".paginationBoutique",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperProducts: {
					freeMode: true,
					freeModeMomentum: false,
					slidesPerView: "auto",
					observer: true,
					observeParents: true
				},
				autoLocationPoint: {
					lng: 0,
					lat: 0
				},
				address: {
					province: '',
					city: ''
				},
				initLocation: false,
				userInfo: {},
				orderStatusNum:'123'
			};
		},
		mounted: function() {

			let that = this;
			
			getHomeData().then(res => {
				that.logoUrl = res.data.logoUrl;
				that.newGoodsBananr = res.data.newGoodsBananr;
				that.$set(that, "banner", res.data.banner);
				that.$set(that, "menus", res.data.menus);
				that.$set(that, "roll", res.data.roll);
				that.$set(that, "videl", res.data.videoList);
				that.$set(that, "teat", res.data.guanggao);
				that.$set(that, "botm", res.data.bottom);
				that.$set(that, "tetp", res.data.jianjie);
				that.$set(that, "activity", res.data.activity);
				that.$set(that, "zscxImg", res.data.zscx[0].img);
				that.$set(that, "zscxUrl", res.data.zscx[0].url);
				if (res.data.activity.length) {
					var activityOne = res.data.activity.shift();
					that.$set(that, "activityOne", activityOne);
				}
				that.$set(that, "info", res.data.info);
				that.$set(that,"likeInfo", res.data.likeInfo)
				that.$set(that, "phone", res.data.userdetail.phone);
				// that.$set(that, "info", res.data.info);
				// that.$set(that, "likeInfo", res.data.likeInfo);
				that.$set(
					that,
					"lovely",
					res.data.lovely.length ? res.data.lovely[0] : {}
				);
				that.$set(that, "benefit", res.data.benefit);
				that.$set(that, "couponList", res.data.couponList);
				that.subscribe = res.data.subscribe;
				that.setOpenShare();
				this.showCoupon = !cookie.has(HAS_COUPON_WINDOW) &&
					res.data.couponList.some(coupon => coupon.is_use);
				if( res.data.userdetail.phone == '' && res.data.userdetail.user_type == ''){
						this.$Message.info("查询");
					}else{
						return that.$dialog.toast({
						  mes: "请前往'我的'绑定手机号"
						}); 
					}
				
			});
			this.getFollow();
			this.handler(); //触发获取城市方法 
			
		},
		methods: { 
			handler({
				BMap,
				map
			}) {
				let _this = this; // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
				var geolocation = new BMap.Geolocation();
				geolocation.getCurrentPosition(function(r) {
					console.log(r);
					_this.autoLocationPoint = {
						lng: r.longitude,
						lat: r.latitude
					}; // 当前坐标
					_this.address = {
						province: r.address.province,
						city: r.address.city
					}
				}, {
					enableHighAccuracy: true
				})
			},
			// 点击第五额调其他 
			closeFollow() {
				this.followHid = false;
			},
			followTap() {
				this.followCode = true;
				this.followHid = false;
			},
			closeFollowCode() {
				this.followCode = false;
				this.followHid = true;
			},
			couponClose() {
				cookie.set(HAS_COUPON_WINDOW, 1);
			},
			getFollow() {
				
				follow()
					.then(res => {
						this.followUrl = res.data.path;
					})
					.catch(() => {});
					console.log(res)
			},
			setOpenShare() {
				if (isWeixin()) {
					getShare().then(res => {
						var data = res.data.data;
						var configAppMessage = {
							desc: data.synopsis,
							title: data.title,
							link: location.href,
							imgUrl: data.img
						};
						openShareAll(configAppMessage);
					});
				}
			}
		}
	};
</script>
<style scoped>
	.index {
		background-color: #fff;
	}

	.index .follow {
		z-index: 100000;
	}

	.bonLoop {
		width: 90%;
		height: 2rem;
		margin: 0 auto;
		background-color: #ccc;
	}
	.bonLoop a img{
		width: 100%;
		height: 100%;
	}

	.acer-rit {
		padding-top: 0;
	} 
</style>
